export const SET_BUNDLE = 'SET_BUNDLE'
export const RESET_BUNDLE = 'RESET_BUNDLE'